import { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../state/useAuth';
import { useAuthModal } from '../state/AuthModalContext';
import '../styles/theme.css';

export default function AvatarMenu(){
  const { isLogged, isAdmin, role, model, avatarUrl, logout } = useAuth();
  const { openAuth } = useAuthModal();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e){
      if(!ref.current) return;
      if(!ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  const initials = (model?.name || model?.username || 'A').slice(0,2).toUpperCase();

  return (
    <div ref={ref} style={{position:'relative'}}>
      <button
        aria-label="Mon compte"
        onClick={() => setOpen(v=>!v)}
        style={{
          width:38,height:38,borderRadius:'9999px',border:'1px solid #e5e7eb',
          display:'grid',placeItems:'center',background:'#fff',cursor:'pointer'
        }}
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt="avatar" style={{width:'100%',height:'100%',borderRadius:'9999px',objectFit:'cover'}}/>
        ) : (
          <span style={{fontSize:12,fontWeight:700,color:'#334155'}}>{initials}</span>
        )}
      </button>
      {open && (
        <div style={{position:'absolute',right:0,marginTop:8,background:'#fff',border:'1px solid #eef0f2',borderRadius:12,minWidth:200,boxShadow:'0 8px 24px rgba(0,0,0,0.08)',overflow:'hidden'}}>
          {!isLogged && (
            <div>
              <button onClick={()=>{ openAuth('login'); setOpen(false); }} style={{...itemStyle, width:'100%', textAlign:'left', background:'none', border:'none', cursor:'pointer'}}>Se connecter</button>
              <button onClick={()=>{ openAuth('register'); setOpen(false); }} style={{...itemStyle, width:'100%', textAlign:'left', background:'none', border:'none', cursor:'pointer'}}>Créer un compte</button>
            </div>
          )}
          {isLogged && (
            <div>
              <div style={{padding:'10px 12px',borderBottom:'1px solid #f1f5f9',fontWeight:600}}>{model?.name || model?.username}</div>
              <NavLink to="/account" onClick={()=>setOpen(false)} style={itemStyle}>Mon compte</NavLink>
              {(role === 'worker' || isAdmin || role === 'commercial') && (
                <NavLink to="/mon-planning" onClick={()=>setOpen(false)} style={itemStyle}>Mon Planning</NavLink>
              )}
              {(isAdmin || role === 'commercial') && (
                <NavLink to="/admin" onClick={()=>setOpen(false)} style={itemStyle}>Administration</NavLink>
              )}
              <button onClick={()=>{logout(); setOpen(false); nav('/');}} style={{...itemStyle, width:'100%', textAlign:'left', background:'none', border:'none', cursor:'pointer'}}>Se déconnecter</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const itemStyle = {display:'block', padding:'10px 12px', color:'#334155', textDecoration:'none'};
